(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["available-offers"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var copyButtons = document.querySelectorAll('.copy-btn');

    copyButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var couponCode = this.getAttribute('data-clipboard-text');

        navigator.clipboard
          .writeText(couponCode)
          .then(function () {
            button.textContent = 'Copied!';
            setTimeout(function () {
              button.textContent = 'Copy';
            }, 3000);
          })
          .catch(function (err) {
            console.error('Failed to copy text: ', err);
          });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coll-footer-collapsible"]) return;
  try {
    
  var coll = document.getElementsByClassName('collapsible');
  var i;

  for (i = 0; i < coll.length; i++) {
    coll[i].addEventListener('click', function () {
      this.classList.toggle('active');
      var content = this.nextElementSibling;
      if (content.style.display === 'block') {
        content.style.display = 'none';
      } else {
        content.style.display = 'block';
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var items = document.querySelectorAll('[data-faq-item]');

    function closeItem(item) {
      var trigger = item.querySelector('[data-faq-trigger]');
      var answer = item.querySelector('.pdp-faq__answer');

      answer.style.height = answer.scrollHeight + 'px';

      requestAnimationFrame(function () {
        answer.style.height = '0px';
      });

      item.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      answer.setAttribute('aria-hidden', 'true');
    }

    function openItem(item) {
      var trigger = item.querySelector('[data-faq-trigger]');
      var answer = item.querySelector('.pdp-faq__answer');

      item.classList.add('is-open');
      answer.style.height = 'auto';

      var height = answer.scrollHeight;

      answer.style.height = '0px';

      requestAnimationFrame(function () {
        answer.style.height = height + 'px';
      });

      answer.addEventListener('transitionend', function handler() {
        if (item.classList.contains('is-open')) {
          answer.style.height = 'auto';
        }
        answer.removeEventListener('transitionend', handler);
      });

      trigger.setAttribute('aria-expanded', 'true');
      answer.setAttribute('aria-hidden', 'false');
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-faq-trigger]');

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        items.forEach(function (el) {
          if (el !== item && el.classList.contains('is-open')) {
            closeItem(el);
          }
        });

        if (isOpen) {
          closeItem(item);
        } else {
          openItem(item);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-footer-collapsible"]) return;
  try {
    
   var coll = document.getElementsByClassName("collapsible");
  var i;

  for (i = 0; i < coll.length; i++) {
    coll[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var content = this.nextElementSibling;
      if (content.style.display === "block") {
        content.style.display = "none";
      } else {
        content.style.display = "block";
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
